import { redirect } from 'react-router-dom';
import { fetchActiveRefill, fetchCreditCards } from '@api';
import { useApplicationStore } from '@data';
import { refetchAndSetPatientProfile } from '@router/loaders/utils';

export default async function refillsLoader(): Promise<Response | null> {
  const { patient } = useApplicationStore.getState();
  const {
    activeRefill,
    creditCards,
    patientProfile,
    setActiveRefill,
    setPatientCreditCards,
  } = patient;

  const untypedPromises: Promise<unknown>[] = [];
  if (!patientProfile) {
    try {
      await refetchAndSetPatientProfile();
    } catch {
      return redirect('/services');
    }
  }

  if (!creditCards) {
    try {
      untypedPromises.push(
        fetchCreditCards().then((x) => setPatientCreditCards(x)),
      );
    } catch {
      // @TODO: Handle error
    }
  }

  if (!activeRefill) {
    try {
      untypedPromises.push(fetchActiveRefill().then((x) => setActiveRefill(x)));
    } catch {
      // @TODO: Handle error
    }
  }

  try {
    await Promise.all(untypedPromises);
    return null;
  } catch {
    // @TODO: Handle error
    return null;
  }
}
